import { render } from "./ReturnLoads.vue?vue&type=template&id=27399a92"
import script from "./ReturnLoads.vue?vue&type=script&lang=js"
export * from "./ReturnLoads.vue?vue&type=script&lang=js"

import "./ReturnLoads.vue?vue&type=style&index=0&id=27399a92&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__